// @flow
import $ from 'jquery';
import axios from 'axios';
import { loader } from './loader';

/**
 * Wykonuje zapytanie ajaxowe
 * @param {Object} options - opcje do zapytania ajaxowego, metoda, payload itp.
 * @param {Function} callback - funkcja wywolywana po wykonaniu zapytania
 */
function makeRequest(options: Object, callback: Function) {
    loader.show();

    return axios({
        method: options.method,
        url: options.url,
        data: options.payload || '',
    }).then((response: Object) => {
        if (callback) {
            callback();
        }
        loader.hide(response);
        return response;
    }).catch((response: Object) => {
        loader.hide(response);
        return response;
    });
}

/**
 * Binduje metode makeRequest do buttonow z klasa .js-ajax
 */
function bindAjaxButtons() {
    $(document).on('click', '.js-ajax', function (e) {
        const options = $(this).data('ajax');
        if (options) {
            makeRequest(options);
        } else {
            throw new Error('No data-ajax attribute !');
        }
        e.preventDefault();
    });
}

export { makeRequest, bindAjaxButtons };



// WEBPACK FOOTER //
// ./src/_app/layout/request.js